import RichText from '@/components/ui/RichText'
import MobiHeaderUnderline from '@/components/ui/MobiUnderline'
import { useLanguage } from '@/context/LanguageContext'
import { ServiceContent } from '@/services/cms-api/service-menu/types'
import { resolveImageUrl } from '@/utils/constants'
import { isNil } from '@/utils/validations'
import classNames from 'classnames'
import Image from 'next/image'
import { FunctionComponent } from 'react'

interface Prop {
  content: ServiceContent
  idx: number
}
const ServiceContentRenderer: FunctionComponent<Prop> = ({ content, idx }) => {
  const { locale } = useLanguage()
  if (content === undefined) {
    return <></>
  }
  return (
    <div className='w-full flex flex-col'>
      <div className={classNames('pt-4 w-full flex flex-col text-sm gap-4 md:gap-8 xl:items-center md:items-start justify-start md:text-base', idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse')}>
        {
          (!isNil(content.imageEn) && !isNil(content.imageMn)) && (
            <Image
              draggable={false}
              alt='img'
              width={1000}
              height={1000}
              className={classNames(content.bodyEn !== null && content.bodyMn !== null ? 'md:w-2/5' : 'w-full')}
              src={resolveImageUrl((locale === 'en' ? content.imageEn : content.imageMn))}
            />
          )
        }
        <div className='w-full'>
          {(!isNil(content.headerEn) && !isNil(content.headerMn)) && (
            <div className='flex flex-col justify-self-start'>
              <h1 className='font-bold lg:text-4xl text-xl text-textHigh'>{locale === 'en' ? content.headerEn : content.headerMn}</h1>
              <MobiHeaderUnderline />
            </div>
          )}
          {
            (content.bodyEn !== null && content.bodyMn !== null) && (
              <div className='text-justify'>
                <RichText content={locale === 'en' ? content.bodyEn : content.bodyMn} />
              </div>
            )
          }
        </div>

      </div>
    </div>
  )
}
export default ServiceContentRenderer
